import { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import AuthModal from '../Modal/AuthenticateModal';

interface ActionBarProps {
    role: string|null;
    isSubmitting: boolean;
    isSaved: boolean;
    onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onSave: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onView: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function ActionBar({role, isSaved, isSubmitting, onSave, onSubmit, onView}: ActionBarProps) {
    const [submitModalOpen, setSubmitModalOpen] = useState(false);
     
    const openSubmitAuthModal = () => {
        setSubmitModalOpen(true); 
    };
	
    const closeSubmitAuthModal = () => {
        setSubmitModalOpen(false); 
    };

    const [saveDraftModalOpen, setSaveDraftModalOpen] = useState(false); 

    const openSaveDraftAuthModal = () => {
        setSaveDraftModalOpen(true); 
    };
	
    const closeSaveDraftAuthModal = () => {
        setSaveDraftModalOpen(false); 
    };

    return (
        <>
            <AuthModal
                isOpen={submitModalOpen}
                onClose={closeSubmitAuthModal}
                title="Action Verification"
                content={<div className="text-base mb-3">Are you sure you want to submit this as a content?</div>}
                footer={
                    <>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                            onClick={closeSubmitAuthModal}>
                            Close
                        </button>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                            onClick={onSubmit}
                            disabled={isSubmitting}>
                            {isSubmitting ? 'Confirming...' : 'Confirm'}
                        </button>
                    </>
                }
            />

            <AuthModal
                isOpen={saveDraftModalOpen}
                onClose={closeSaveDraftAuthModal}
                title="Action Verification"
                content={<div className="text-base mb-3">Are you sure you want to save this as a draft?</div>}
                footer={
                    <>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                            onClick={closeSaveDraftAuthModal}>
                            Close
                        </button>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                            onClick={onSave}
                            disabled={isSubmitting}>
                            {isSubmitting ? 'Confirming...' : 'Confirm'}
                        </button>
                    </>
                }
            />

            <div>
                <div className="flex gap-2">
                    {(role === 'Magazine' || role === 'Live' || role === 'IT') && (
                        <Button variant='danger' className="Univers-BoldCondensed" type='button' onClick={openSubmitAuthModal} disabled={isSubmitting}>
                            {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                        </Button>
                    )}

                    <Button variant="secondary" className="Univers-BoldCondensed" type="button" onClick={openSaveDraftAuthModal}> 
                        {isSaved ? "SAVING..." : "SAVE AS DRAFT"}
                    </Button>

                    <Button variant="danger" type="button" data-tooltip-id="preview" onClick={onView}> 
                        <FontAwesomeIcon icon={faEye} />
                    </Button>
                </div>
            </div>
        </>
    )
}